var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"href":"https://localhost","target":"_blank","aria-label":"View source on Github"}})}
var staticRenderFns = []

export { render, staticRenderFns }